import { Col, Row } from 'react-bootstrap';
import { AvailableForLoans } from './loansCards/available-for-loans';
import { CurrentLoans } from './loansCards/current-loans';

export const Loans = () => {
  return (
    <>
      <Row className={'mt-9'}>
        <Col className={'col-lg-6 col-12'}>
          <CurrentLoans />
        </Col>
        <Col className={'col-lg-6 col-12 mt-8 mt-lg-0'}>
          <AvailableForLoans />
        </Col>
      </Row>
    </>
  );
};
